import { getTypesenseClient } from '@util/getTypesense';

export type Suggestion = {
  id: string;
  q: string;
  count: number;
};

export const fetchSuggestions = async (query: string) => {
  const res = await getTypesenseClient<Suggestion>('product_queries', 'long')
    .documents()
    .search({
      q: query,
      query_by: 'q',
      sort_by: 'count:desc',
      per_page: 10,
      exhaustive_search: true,
    });
  return res.hits ?? [];
};

export const fetchCategorySuggestions = async (
  query: string,
  category: string
) => {
  const res = await getTypesenseClient<Suggestion>('product_queries', 'long')
    .documents()
    .search({
      q: query,
      query_by: 'q',
      filter_by: `categories:=${category}`,
      sort_by: 'count:desc',
      per_page: 7,
    });

  return res.hits;
};
